import { render } from "./SiteContent.vue?vue&type=template&id=277e7013"
import script from "./SiteContent.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteContent.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SitesDash/manage/SiteContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "277e7013"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('277e7013', __exports__)) {
    api.reload('277e7013', __exports__)
  }
  
  module.hot.accept("./SiteContent.vue?vue&type=template&id=277e7013", () => {
    api.rerender('277e7013', render)
  })

}


export default __exports__